export interface MangaItem {
  id: number;
  title: string;
  cover: string;
  tags: string[];
  rating: number;
  status: string;
  desc: string;
  category: string;
  chapter: string;
  views: string;
}

export interface Category {
  id: string;
  name: string;
  en: string;
  icon: string;
  image: string;
  desc: string;
  count: string;
}

export const heroBg =
  "https://readdy.ai/api/search-image?query=dark%20surreal%20ink%20manga%20backdrop%20of%20an%20endless%20underground%20corridor%20of%20doors%20vanishing%20into%20shadow%2C%20eerie%20crimson%20glow%20at%20the%20end%2C%20heavy%20grain%20and%20paper%20texture%2C%20noir%20psychological%20horror%20atmosphere%2C%20deep%20near-black%20tones%20with%20blood%20red%20accent%20lighting%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=wai-hero-01&orientation=landscape";

export const categories: Category[] = [
  {
    id: "guaitan",
    name: "都市怪谈",
    en: "URBAN MYTHS",
    icon: "ri-ghost-line",
    image:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20dim%20neon%20alley%20in%20a%20rainy%20night%20city%2C%20a%20shadowy%20figure%20with%20glowing%20red%20eyes%20between%20buildings%2C%20fog%20and%20grain%2C%20noir%20urban%20horror%2C%20deep%20black%20with%20crimson%20and%20amber%20accents&width=600&height=800&seq=wai-cat-guaitan&orientation=portrait",
    desc: "藏在灯火背后的低语与传说",
    count: "128 部",
  },
  {
    id: "bingtai",
    name: "病态美学",
    en: "GROTESQUE AESTHETIC",
    icon: "ri-mental-health-line",
    image:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20surreal%20anatomical%20garden%20with%20crimson%20flowers%20growing%20from%20marble%20statues%2C%20gothic%20moody%20lighting%2C%20grotesque%20beauty%2C%20deep%20black%20background%20with%20deep%20red%20and%20bone%20white%20details&width=600&height=800&seq=wai-cat-bingtai&orientation=portrait",
    desc: "在扭曲中寻找失控的美感",
    count: "96 部",
  },
  {
    id: "feitu",
    name: "末日废土",
    en: "WASTELAND",
    icon: "ri-fire-line",
    image:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20solitary%20survivor%20walking%20through%20a%20burning%20ruined%20city%20under%20a%20blood%20red%20sky%2C%20embers%20and%20ash%20in%20the%20wind%2C%20post%20apocalyptic%20noir%2C%20deep%20black%20with%20crimson%20and%20smoldering%20orange%20accents&width=600&height=800&seq=wai-cat-feitu&orientation=portrait",
    desc: "文明熄灭后的冰冷生存法则",
    count: "84 部",
  },
  {
    id: "jinyi",
    name: "禁忌异闻",
    en: "FORBIDDEN LORE",
    icon: "ri-sword-line",
    image:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20an%20ancient%20sealed%20shrine%20door%20covered%20in%20crimson%20talismans%20and%20chains%2C%20mysterious%20wraith%20mist%20leaking%20out%2C%20oriental%20dark%20fantasy%2C%20deep%20black%20with%20red%20and%20gold%20accents&width=600&height=800&seq=wai-cat-jinyi&orientation=portrait",
    desc: "不应被翻开的一页",
    count: "77 部",
  },
  {
    id: "xinli",
    name: "暗黑心理",
    en: "DARK PSYCHE",
    icon: "ri-eye-line",
    image:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20cracked%20mirror%20reflecting%20a%20faceless%20silhouette%2C%20surreal%20psychological%20horror%2C%20crimson%20light%20leaking%20through%20cracks%2C%20deep%20black%20background%20with%20red%20and%20gray%20tones&width=600&height=800&seq=wai-cat-xinli&orientation=portrait",
    desc: "直视内心最深处的裂缝",
    count: "112 部",
  },
  {
    id: "yinghe",
    name: "硬核猎奇",
    en: "HARDCORE GORE",
    icon: "ri-skull-line",
    image:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20laboratory%20operating%20table%20with%20intricate%20anatomical%20sketches%20overlayed%2C%20clinical%20yet%20nightmarish%2C%20crimson%20and%20cold%20steel%20tones%2C%20deep%20black%20background%2C%20hardcore%20biopunk%20horror%20artwork&width=600&height=800&seq=wai-cat-yinghe&orientation=portrait",
    desc: "挑战感官边界的硬核叙事",
    count: "65 部",
  },
];

export const hotMangas: MangaItem[] = [
  {
    id: 1,
    title: "深渊回响",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20an%20abandoned%20underground%20train%20car%20in%20eerie%20red%20lighting%2C%20fog%20on%20the%20empty%20platform%2C%20a%20distorted%20silhouette%20in%20the%20window%2C%20noir%20psychological%20horror%2C%20deep%20black%20with%20crimson%20accents&width=600&height=800&seq=wai-hot-01&orientation=portrait",
    tags: ["都市怪谈", "悬疑"],
    rating: 9.4,
    status: "连载中",
    desc: "每当午夜列车驶过第六站台，车内总会多出一个没人记得的乘客。",
    category: "都市怪谈",
    chapter: "第 128 话",
    views: "326 万",
  },
  {
    id: 2,
    title: "血月食堂",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20dim%20midnight%20diner%20with%20a%20single%20glowing%20red%20lantern%2C%20steaming%20plates%20and%20shadowy%20guests%2C%20grotesque%20gourmet%20horror%2C%20deep%20black%20with%20crimson%20and%20warm%20orange%20accents&width=600&height=800&seq=wai-hot-02&orientation=portrait",
    tags: ["病态美学", "美食"],
    rating: 9.2,
    status: "连载中",
    desc: "菜单上只有一道菜：用你的执念做成的晚宴。吃下去，就回不去了。",
    category: "病态美学",
    chapter: "第 86 话",
    views: "218 万",
  },
  {
    id: 3,
    title: "最后一班地铁",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20closed%20subway%20station%20gate%20with%20a%20faint%20red%20headlight%20approaching%20in%20the%20tunnel%2C%20empty%20ticket%20hall%20with%20floating%20dust%2C%20urban%20horror%2C%20deep%20black%20with%20crimson%20accents&width=600&height=800&seq=wai-hot-03&orientation=portrait",
    tags: ["禁忌异闻", "悬疑"],
    rating: 8.9,
    status: "已完结",
    desc: "末班车从不按时刻表进站，它只在你最疲惫的时候停靠。",
    category: "禁忌异闻",
    chapter: "全 54 话",
    views: "196 万",
  },
  {
    id: 4,
    title: "解剖室手记",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20dim%20morgue%20with%20gleaming%20steel%20tables%20and%20blue%20red%20mixed%20moody%20lighting%2C%20an%20open%20notebook%20with%20hand%20drawn%20anatomical%20sketches%2C%20biopunk%20hardcore%20horror%2C%20deep%20black%20background&width=600&height=800&seq=wai-hot-04&orientation=portrait",
    tags: ["硬核猎奇", "科幻"],
    rating: 9.0,
    status: "连载中",
    desc: "一位验尸官记录下的每一具遗体，都在死后说出不同的真相。",
    category: "硬核猎奇",
    chapter: "第 71 话",
    views: "184 万",
  },
  {
    id: 5,
    title: "镜中人",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20gothic%20vanity%20mirror%20where%20the%20reflection%20has%20a%20slightly%20different%20expression%2C%20crimson%20velvet%20drapes%2C%20psychological%20horror%20surrealism%2C%20deep%20black%20with%20red%20accents&width=600&height=800&seq=wai-hot-05&orientation=portrait",
    tags: ["暗黑心理", "惊悚"],
    rating: 9.1,
    status: "连载中",
    desc: "镜子里的你总是慢半拍，直到某天，他决定先于你行动。",
    category: "暗黑心理",
    chapter: "第 103 话",
    views: "241 万",
  },
  {
    id: 6,
    title: "废土拾荒者",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20masked%20scavenger%20sorting%20through%20rubble%20beneath%20a%20blood%20red%20sky%2C%20rusty%20wasteland%20with%20ash%20falling%2C%20post%20apocalyptic%20noir%2C%20deep%20black%20with%20crimson%20and%20amber%20accents&width=600&height=800&seq=wai-hot-06&orientation=portrait",
    tags: ["末日废土", "冒险"],
    rating: 8.8,
    status: "连载中",
    desc: "在灰烬世界里，每捡到一件旧物，都意味着又一次与过去的对峙。",
    category: "末日废土",
    chapter: "第 66 话",
    views: "159 万",
  },
  {
    id: 7,
    title: "无声诊所",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20an%20empty%20dim%20clinic%20corridor%20with%20paper%20lanterns%20and%20a%20wheelchair%20at%20the%20end%2C%20fog%2C%20eerie%20medical%20horror%2C%20deep%20black%20with%20muted%20red%20accents&width=600&height=800&seq=wai-hot-07&orientation=portrait",
    tags: ["暗黑心理", "医疗"],
    rating: 8.7,
    status: "已完结",
    desc: "这家诊所的挂号单上，写的都是没人愿意承认的病。",
    category: "暗黑心理",
    chapter: "全 48 话",
    views: "137 万",
  },
  {
    id: 8,
    title: "面具集会",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20secret%20cult%20meeting%20in%20a%20cathedral%20basement%2C%20rows%20of%20ceramic%20masks%20with%20candlelight%2C%20crimson%20robes%2C%20cult%20horror%20noir%2C%20deep%20black%20with%20red%20and%20candle%20gold%20accents&width=600&height=800&seq=wai-hot-08&orientation=portrait",
    tags: ["邪典", "心理"],
    rating: 9.0,
    status: "连载中",
    desc: "戴上假面的人越来越多，摘下来的时候，都忘了自己原来的样子。",
    category: "邪典",
    chapter: "第 59 话",
    views: "172 万",
  },
];

export const cultSeries: MangaItem[] = [
  {
    id: 101,
    title: "午夜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20an%20old%20cinema%20marquee%20with%20broken%20red%20neon%20letters%20at%20midnight%2C%20a%20single%20projector%20beam%20and%20scattered%20velvet%20seats%2C%20cult%20cinema%20horror%2C%20deep%20black%20with%20crimson%20neon%20accents&width=600&height=800&seq=wai-cult-01&orientation=portrait",
    tags: ["邪典", "都市怪谈"],
    rating: 9.5,
    status: "经典完更",
    desc: "票根上印着的场次从不出现在排片表上，只有懂的人能入场。",
    category: "邪典",
    chapter: "全 120 话",
    views: "412 万",
  },
  {
    id: 102,
    title: "钟楼怪物",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20gothic%20cathedral%20clock%20tower%20at%20night%20with%20a%20huge%20shadowy%20creature%20clinging%20to%20the%20spire%2C%20crimson%20moon%2C%20gothic%20horror%20noir%2C%20deep%20black%20with%20red%20accents&width=600&height=800&seq=wai-cult-02&orientation=portrait",
    tags: ["邪典", "哥特"],
    rating: 9.3,
    status: "经典完更",
    desc: "每当钟声敲响第十三下，塔顶的怪物就会换一副面孔。",
    category: "邪典",
    chapter: "全 96 话",
    views: "358 万",
  },
  {
    id: 103,
    title: "失真录",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20glitching%20vintage%20television%20screen%20in%20a%20dark%20room%20emitting%20static%20and%20red%20distortion%2C%20a%20silhouette%20emerging%2C%20analog%20horror%2C%20deep%20black%20with%20crimson%20static%20accents&width=600&height=800&seq=wai-cult-03&orientation=portrait",
    tags: ["邪典", "恐怖"],
    rating: 8.9,
    status: "连载中",
    desc: "这台老电视只会播放一段反复循环的画面，而画面里的人认得你。",
    category: "邪典",
    chapter: "第 47 话",
    views: "204 万",
  },
];

export const darkSeries: MangaItem[] = [
  {
    id: 201,
    title: "黑潮之下",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20coastal%20town%20submerged%20in%20an%20endless%20black%20tide%20under%20a%20crimson%20sky%2C%20a%20lighthouse%20with%20a%20red%20beam%2C%20cosmic%20horror%20noir%2C%20deep%20black%20with%20crimson%20accents&width=600&height=800&seq=wai-dark-01&orientation=portrait",
    tags: ["末日废土", "深海"],
    rating: 8.9,
    status: "连载中",
    desc: "海水在黎明前上涨，从不见退去，小镇一天比一天沉得更深。",
    category: "末日废土",
    chapter: "第 88 话",
    views: "267 万",
  },
  {
    id: 202,
    title: "深红档案",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20government%20vault%20of%20classified%20files%20lit%20by%20a%20single%20red%20emergency%20lamp%2C%20stamped%20seals%20and%20filing%20cabinets%2C%20conspiracy%20noir%2C%20deep%20black%20with%20crimson%20accents&width=600&height=800&seq=wai-dark-02&orientation=portrait",
    tags: ["禁忌异闻", "悬疑"],
    rating: 9.1,
    status: "连载中",
    desc: "每一份被封存的档案里，都藏着一个不该被公开的真相。",
    category: "禁忌异闻",
    chapter: "第 64 话",
    views: "231 万",
  },
  {
    id: 203,
    title: "边界信徒",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20procession%20of%20hooded%20figures%20walking%20toward%20a%20blinding%20red%20horizon%20over%20a%20flat%20desert%2C%20religious%20cult%20horror%2C%20deep%20black%20with%20crimson%20and%20white%20accents&width=600&height=800&seq=wai-dark-03&orientation=portrait",
    tags: ["邪典", "心理"],
    rating: 8.8,
    status: "连载中",
    desc: "朝圣的终点是一片空白，可信徒们依然坚信那里住着神明。",
    category: "邪典",
    chapter: "第 39 话",
    views: "143 万",
  },
];

export const brainPicks: MangaItem[] = [
  {
    id: 301,
    title: "平行早餐",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20dreamlike%20kitchen%20where%20the%20table%20and%20chairs%20are%20mirrored%20and%20floating%2C%20surreal%20everyday%20horror%2C%20crimson%20and%20cream%20tones%2C%20deep%20black%20background%2C%20mind%20bending%20composition&width=600&height=800&seq=wai-brain-01&orientation=portrait",
    tags: ["脑洞", "日常"],
    rating: 9.0,
    status: "连载中",
    desc: "每天早上，主角都在另一个平行世界里重新醒来，早餐内容却永远一样。",
    category: "脑洞",
    chapter: "第 52 话",
    views: "190 万",
  },
  {
    id: 302,
    title: "反转宇宙",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20swirling%20fractal%20cosmos%20with%20planets%20inside%20an%20hourglass%2C%20surreal%20space%20horror%2C%20crimson%20nebula%20and%20black%20void%2C%20mind%20bending%20sci-fi%20artwork%2C%20deep%20black%20background&width=600&height=800&seq=wai-brain-02&orientation=portrait",
    tags: ["脑洞", "科幻"],
    rating: 9.2,
    status: "连载中",
    desc: "当宇宙开始向内塌缩，所有因果都会在最后三秒被重新书写。",
    category: "脑洞",
    chapter: "第 44 话",
    views: "176 万",
  },
  {
    id: 303,
    title: "时间乘客",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20lone%20figure%20standing%20on%20a%20railway%20platform%20where%20multiple%20clocks%20float%20at%20different%20angles%2C%20time%20travel%20surreal%20horror%2C%20crimson%20and%20deep%20blue%20black%20tones%2C%20deep%20black%20background%2C%20dreamlike%20composition&width=600&height=800&seq=wai-brain-03&orientation=portrait",
    tags: ["脑洞", "悬疑"],
    rating: 8.9,
    status: "已完结",
    desc: "乘客只能前往未来，却永远无法回到出发的那一天。",
    category: "脑洞",
    chapter: "全 40 话",
    views: "158 万",
  },
];

export const rankings: MangaItem[] = [
  {
    id: 401,
    title: "午夜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20an%20old%20cinema%20with%20crimson%20neon%20letters%20and%20projector%20beam%2C%20cult%20cinema%20horror%2C%20deep%20black%20with%20red%20accents&width=400&height=520&seq=wai-rank-01&orientation=portrait",
    tags: ["邪典", "都市怪谈"],
    rating: 9.5,
    status: "经典完更",
    desc: "票根上印着的场次从不出现在排片表上。",
    category: "邪典",
    chapter: "全 120 话",
    views: "412 万",
  },
  {
    id: 402,
    title: "深渊回响",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20an%20abandoned%20subway%20car%20in%20red%20lighting%20with%20a%20distorted%20silhouette%2C%20noir%20horror%2C%20deep%20black%20with%20crimson%20accents&width=400&height=520&seq=wai-rank-02&orientation=portrait",
    tags: ["都市怪谈", "悬疑"],
    rating: 9.4,
    status: "连载中",
    desc: "午夜列车的第六站台总多出一个乘客。",
    category: "都市怪谈",
    chapter: "第 128 话",
    views: "326 万",
  },
  {
    id: 403,
    title: "钟楼怪物",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20gothic%20clock%20tower%20with%20a%20shadowy%20creature%20and%20crimson%20moon%2C%20gothic%20horror%2C%20deep%20black%20with%20red%20accents&width=400&height=520&seq=wai-rank-03&orientation=portrait",
    tags: ["邪典", "哥特"],
    rating: 9.3,
    status: "经典完更",
    desc: "钟声敲响第十三下时怪物换一副面孔。",
    category: "邪典",
    chapter: "全 96 话",
    views: "358 万",
  },
  {
    id: 404,
    title: "反转宇宙",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20fractal%20cosmos%20inside%20an%20hourglass%20with%20red%20nebula%2C%20surreal%20sci-fi%2C%20deep%20black%20background&width=400&height=520&seq=wai-rank-04&orientation=portrait",
    tags: ["脑洞", "科幻"],
    rating: 9.2,
    status: "连载中",
    desc: "宇宙向内塌缩时因果会被重新书写。",
    category: "脑洞",
    chapter: "第 44 话",
    views: "176 万",
  },
  {
    id: 405,
    title: "血月食堂",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20dim%20midnight%20diner%20with%20red%20lantern%20and%20steaming%20plates%2C%20grotesque%20gourmet%20horror%2C%20deep%20black%20with%20crimson%20and%20orange%20accents&width=400&height=520&seq=wai-rank-05&orientation=portrait",
    tags: ["病态美学", "美食"],
    rating: 9.2,
    status: "连载中",
    desc: "菜单上只有一道用执念做成的晚宴。",
    category: "病态美学",
    chapter: "第 86 话",
    views: "218 万",
  },
  {
    id: 406,
    title: "深红档案",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20vault%20of%20classified%20files%20lit%20by%20red%20emergency%20lamp%2C%20conspiracy%20noir%2C%20deep%20black%20with%20crimson%20accents&width=400&height=520&seq=wai-rank-06&orientation=portrait",
    tags: ["禁忌异闻", "悬疑"],
    rating: 9.1,
    status: "连载中",
    desc: "每一份被封存的档案里都藏着真相。",
    category: "禁忌异闻",
    chapter: "第 64 话",
    views: "231 万",
  },
  {
    id: 407,
    title: "镜中人",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20gothic%20vanity%20mirror%20with%20a%20different%20reflection%2C%20crimson%20velvet%2C%20psychological%20horror%2C%20deep%20black%20with%20red%20accents&width=400&height=520&seq=wai-rank-07&orientation=portrait",
    tags: ["暗黑心理", "惊悚"],
    rating: 9.1,
    status: "连载中",
    desc: "镜子里的你总是慢半拍，直到他先行动。",
    category: "暗黑心理",
    chapter: "第 103 话",
    views: "241 万",
  },
  {
    id: 408,
    title: "平行早餐",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20ink%20manga%20cover%20of%20a%20dreamlike%20floating%20kitchen%20with%20mirrored%20table%2C%20surreal%20everyday%20horror%2C%20deep%20black%20with%20red%20and%20cream%20tones&width=400&height=520&seq=wai-rank-08&orientation=portrait",
    tags: ["脑洞", "日常"],
    rating: 9.0,
    status: "连载中",
    desc: "每天在平行世界重新醒来，早餐却永远一样。",
    category: "脑洞",
    chapter: "第 52 话",
    views: "190 万",
  },
];

export const testimonials = [
  {
    name: "暗夜拾荒",
    role: "猎奇频道老读者",
    avatar:
      "https://readdy.ai/api/search-image?query=dark%20silhouette%20avatar%20portrait%20of%20a%20hooded%20figure%20in%20crimson%20light%2C%20moody%20minimal%20illustration%2C%20deep%20black%20background&width=200&height=200&seq=wai-ava-01&orientation=squarish",
    text: "在歪歪漫画猎奇频道泡了两年多，冷门暗黑题材整理得特别细，很多别处找不到的邪典连载都能在这追到完整版。",
  },
  {
    name: "硬核收藏家",
    role: "重口分类忠实读者",
    avatar:
      "https://readdy.ai/api/search-image?query=dark%20silhouette%20avatar%20portrait%20of%20a%20person%20wearing%20a%20gas%20mask%20with%20red%20glow%2C%20moody%20minimal%20illustration%2C%20deep%20black%20background&width=200&height=200&seq=wai-ava-02&orientation=squarish",
    text: "分类清楚、更新稳定，脑洞和暗黑心理这几个栏目的选品眼光真的毒，基本没有踩雷的。",
  },
  {
    name: "冷门漫荒救援",
    role: "邪典专题订阅者",
    avatar:
      "https://readdy.ai/api/search-image?query=dark%20silhouette%20avatar%20portrait%20of%20a%20reader%20holding%20a%20lantern%20in%20a%20dark%20study%2C%20crimson%20warm%20glow%2C%20moody%20minimal%20illustration%2C%20deep%20black%20background&width=200&height=200&seq=wai-ava-03&orientation=squarish",
    text: "我是被邪典专题拉进来的，从此打开了新世界。这里的榜单和专题推送比我自己淘的效率高太多。",
  },
];

export const faqs = [
  {
    q: "歪歪漫画的猎奇频道适合什么样的读者？",
    a: "歪歪漫画猎奇频道主要面向对暗黑系、邪典、重口及脑洞题材感兴趣的读者。如果你厌倦了主流套路，喜欢非常规、冷门且有深度的故事，这里的内容会更对你的胃口。频道内按题材细分，可以按自己的承受力挑选合适的栏目。",
  },
  {
    q: "网站里的漫画资源是否完整？",
    a: "歪歪漫画将热门连载与冷门完结作做了分类整理，绝大多数作品会跟进到最新话，热门作品保持同步更新。部分极其冷门或早期作品可能存在话数补录中的情况，均会标注当前进度，方便你判断是否入坑。",
  },
  {
    q: "暗黑系、邪典、重口和脑洞这些分类有什么区别？",
    a: "暗黑系偏重压抑、心理与氛围；邪典通常带有离经叛道的主题与实验性叙事；重口更侧重感官冲击与猎奇元素；脑洞则以惊人反转和天马行空的设定见长。每个栏目都有独立专题页，你可以按自己的偏好直接进入。",
  },
  {
    q: "内容会定期更新吗？更新频率如何？",
    a: "会。猎奇频道热门连载保持高频同步，冷门补录与专题推荐每周至少更新一次。你可以在首页的阅读排行与最新更新区查看近期上架的作品与进度变化。",
  },
  {
    q: "我可以反馈作品或推荐冷门佳作吗？",
    a: "当然可以。歪歪漫画非常欢迎读者推荐冷门佳作，我们设有内容建议入口，审核后会纳入对应分类或专题推荐，帮助更多同好发现好作品。",
  },
];